import {
  ESdChangeReason,
  ESymbolCategory,
  IAction,
  IActionParameter,
  IScreenDesign,
  ISymbol
} from "@kuika/kuika-cl-model";
import _ from "lodash";
import * as React from "react";
import isEqual from "react-fast-compare";
import { IWithSDProps, withSD } from "../../../../shared/hoc/screen-design-consumer";
import { IWithContextProp, withContext } from "../../../../shared/hoc/with-context";
import { PureSdComponent } from "../../../../shared/pure-sd";
import KuikaSelectbox, { KuikaSelectboxOption } from "../../../ui-kit/kuika-selectbox/kuika-selectbox";
import { IActionPanelStatesCanBeUpdatedFromChild } from "./action-panel";
import { SymbolPicker } from "./symbol-picker";

const CURRENCY_OPTIONS: KuikaSelectboxOption[] = [
  { key: "TRY", value: "TRY", label: "TRY" },
  { key: "EUR", value: "EUR", label: "EUR" },
  { key: "USD", value: "USD", label: "USD" }
];

const PAYMENT_TYPE_OPTIONS: KuikaSelectboxOption[] = [
  { key: "single", value: "single", label: "Single" },
  { key: "multi", value: "multi", label: "Multi" }
];

export interface IStripePaymentIntentSymbolsGroupState {}

export interface IStripePaymentIntentSymbolsGroupProps {
  action: IAction;
  parameters: IActionParameter[];
  updateValues: (value: IActionPanelStatesCanBeUpdatedFromChild, changeReason?: ESdChangeReason) => void;
}

class StripeChargeSetupIntentSymbolsGroup extends PureSdComponent<
  IStripePaymentIntentSymbolsGroupProps & IWithSDProps & IWithContextProp,
  IStripePaymentIntentSymbolsGroupState
> {
  constructor(props: IStripePaymentIntentSymbolsGroupProps & IWithSDProps & IWithContextProp) {
    super(props);
  }

  componentDidMount() {
    const sd: IScreenDesign = this.props.sd.getScreenDesign();
  }

  handleSelectValues = (value, parameter, changeReason?: ESdChangeReason) => {
    if (value && Array.isArray(value)) {
      value = value.toString();
    }
    const params = _.cloneDeep(this.props.parameters);
    const _parameter = _.cloneDeep(parameter);
    if (!_parameter.symbol) _parameter.symbol = {} as any;
    _parameter.symbol.fixedValue = value;
    _parameter.symbol.category = ESymbolCategory.fixed;
    const valuesToUpdate = {
      actionParameters: params
    } as IActionPanelStatesCanBeUpdatedFromChild;
    valuesToUpdate.actionParameters?.push(_parameter);
    this.props.updateValues(valuesToUpdate, changeReason);
  };

  handleSelectSymbolPickerValue = (parameter: IActionParameter, symbol: ISymbol, changeReason?: ESdChangeReason) => {
    symbol.targetType = "String";
    parameter.Typename = "String";
    const params = _.cloneDeep(this.props.parameters);
    const _parameter = _.cloneDeep(parameter);
    _parameter.symbol = symbol;
    const valuesToUpdate = {
      actionParameters: params
    } as IActionPanelStatesCanBeUpdatedFromChild;
    valuesToUpdate.actionParameters?.push(_parameter);
    this.props.updateValues(valuesToUpdate, changeReason);
  };

  getPaymentTypeValues(paymenttype: IActionParameter) {
    let comaSeperated = paymenttype.symbol?.fixedValue as string;
    return comaSeperated ? comaSeperated.split(",") : undefined;
  }

  renderSymbolPicker = (): JSX.Element => {
    const paymentmethod = this.props.parameters.find((element) => element.name === "paymentmethod");
    const currency = this.props.parameters.find((element) => element.name === "currency");
    const amount = this.props.parameters.find((element) => element.name === "amount");
    const customerStripeId = this.props.parameters.find((element) => element.name === "customerStripeId");
    const description = this.props.parameters.find((element) => element.name === "description");
    const paymenttype = this.props.parameters.find((element) => element.name === "paymenttype");
    const feeamount = this.props.parameters.find((element) => element.name === "feeamount");
    const destination = this.props.parameters.find((element) => element.name === "destination");
    return (
      <>
        <div className="kuika_property-grid-column">
          {/* CaptureMethod */}
          <span style={{ marginBottom: 6, marginTop: 8 }} className="k_Regular-G1-Left kuika_rightPanelDIName">
            Payment Method
          </span>
          <SymbolPicker
            action={_.cloneDeep(this.props.action)}
            changeType="onBlur"
            symbol={_.cloneDeep(paymentmethod!.symbol)}
            valueType={"String"}
            targetCardinality={paymentmethod!.cardinality}
            onSelectedSymbol={(symbol: ISymbol, changeReason?: ESdChangeReason) =>
              this.handleSelectSymbolPickerValue(paymentmethod!, symbol, changeReason)
            }
            bindingParameter={paymentmethod}
            bindingLabel="Payment Method"
          ></SymbolPicker>
        </div>

        <div className="kuika_property-grid-column">
          {/* CaptureMethod */}
          <span style={{ marginBottom: 6, marginTop: 8 }} className="k_Regular-G1-Left kuika_rightPanelDIName">
            Currency
          </span>
          <KuikaSelectbox
            onChange={(value: string): void => this.handleSelectValues(value, currency)}
            style={{ width: "100%" }}
            className="k_Regular-G1-Left"
            value={currency?.symbol?.fixedValue ?? null}
            options={CURRENCY_OPTIONS}
          />
        </div>

        <React.Fragment>
          <span style={{ marginBottom: 6, marginTop: 8 }} className="k_Regular-G1-Left kuika_rightPanelDIName">
            Amount (in cents)
          </span>
          <SymbolPicker
            action={_.cloneDeep(this.props.action)}
            changeType="onBlur"
            symbol={_.cloneDeep(amount!.symbol)}
            valueType={"String"}
            targetCardinality={amount!.cardinality}
            onSelectedSymbol={(symbol: ISymbol, changeReason?: ESdChangeReason) =>
              this.handleSelectSymbolPickerValue(amount!, symbol, changeReason)
            }
            bindingParameter={amount}
            bindingLabel="Amount (in cents)"
          ></SymbolPicker>
        </React.Fragment>

        <React.Fragment>
          <span style={{ marginBottom: 6, marginTop: 8 }} className="k_Regular-G1-Left kuika_rightPanelDIName">
            Description
          </span>
          <SymbolPicker
            action={_.cloneDeep(this.props.action)}
            changeType="onBlur"
            symbol={_.cloneDeep(description!.symbol)}
            valueType={"String"}
            targetCardinality={description!.cardinality}
            onSelectedSymbol={(symbol: ISymbol, changeReason?: ESdChangeReason) =>
              this.handleSelectSymbolPickerValue(description!, symbol, changeReason)
            }
            bindingParameter={description}
            bindingLabel="Description"
          ></SymbolPicker>
        </React.Fragment>
        <div className="kuika_property-grid-column">
          {/* CaptureMethod */}
          <span style={{ marginBottom: 6, marginTop: 8 }} className="k_Regular-G1-Left kuika_rightPanelDIName">
            Customer Mail Address
          </span>
          <SymbolPicker
            action={_.cloneDeep(this.props.action)}
            changeType="onBlur"
            symbol={_.cloneDeep(customerStripeId!.symbol)}
            valueType={"String"}
            targetCardinality={customerStripeId!.cardinality}
            onSelectedSymbol={(symbol: ISymbol, changeReason?: ESdChangeReason) =>
              this.handleSelectSymbolPickerValue(customerStripeId!, symbol, changeReason)
            }
            bindingParameter={customerStripeId}
            bindingLabel="Customer Mail Address"
          ></SymbolPicker>
        </div>
        <div className="kuika_property-grid-column">
          {/* CaptureMethod */}
          <span style={{ marginBottom: 6, marginTop: 8 }} className="k_Regular-G1-Left kuika_rightPanelDIName">
            Single / Multi Part
          </span>
          <KuikaSelectbox
            onChange={(value: string): void => this.handleSelectValues(value, paymenttype)}
            style={{ width: "100%" }}
            className="k_Regular-G1-Left"
            value={paymenttype?.symbol.fixedValue ?? null}
            options={PAYMENT_TYPE_OPTIONS}
          />
        </div>
        {true && (
          <>
            <span
              style={{ marginBottom: 10, marginTop: 14, fontSize: 14 }}
              className="k_Regular-G1-Left kuika_rightPanelDIName"
            >
              Multi Part Config
            </span>
            <React.Fragment>
              <span style={{ marginBottom: 6, marginTop: 8 }} className="k_Regular-G1-Left kuika_rightPanelDIName">
                ApplicationFeeAmount
              </span>
              <SymbolPicker
                action={_.cloneDeep(this.props.action)}
                changeType="onBlur"
                symbol={_.cloneDeep(feeamount!.symbol)}
                valueType={"String"}
                targetCardinality={feeamount!.cardinality}
                onSelectedSymbol={(symbol: ISymbol, changeReason?: ESdChangeReason) =>
                  this.handleSelectSymbolPickerValue(feeamount!, symbol, changeReason)
                }
                bindingParameter={feeamount}
                bindingLabel="ApplicationFeeAmount"
              ></SymbolPicker>
            </React.Fragment>

            <React.Fragment>
              <span style={{ marginBottom: 6, marginTop: 8 }} className="k_Regular-G1-Left kuika_rightPanelDIName">
                Destination
              </span>
              <SymbolPicker
                action={_.cloneDeep(this.props.action)}
                changeType="onBlur"
                symbol={_.cloneDeep(destination!.symbol)}
                valueType={"String"}
                targetCardinality={destination!.cardinality}
                onSelectedSymbol={(symbol: ISymbol, changeReason?: ESdChangeReason) =>
                  this.handleSelectSymbolPickerValue(destination!, symbol, changeReason)
                }
                bindingParameter={destination}
                bindingLabel="Destination"
              ></SymbolPicker>
            </React.Fragment>
          </>
        )}
      </>
    );
  };

  render() {
    return <div style={{ width: "100%" }}>{this.renderSymbolPicker()}</div>;
  }

  checkNeedRender = (changeReason: ESdChangeReason, nextProps: IStripePaymentIntentSymbolsGroupProps): boolean => {
    if (!isEqual(this.props.action, nextProps.action)) {
      return true;
    }
    if (
      changeReason === ESdChangeReason.DiActionUpdated ||
      changeReason === ESdChangeReason.ChangeSelectedDiByCanvasFrame ||
      changeReason === ESdChangeReason.ChangeSelectedDiByTools ||
      changeReason === ESdChangeReason.DragDropDi ||
      changeReason === ESdChangeReason.DragDropBlock ||
      changeReason === ESdChangeReason.WFStepMappingChange
    ) {
      return true;
    }
    return false;
  };
}

const stripePaymentIntentSymbolsGroup = withContext<IStripePaymentIntentSymbolsGroupProps>(
  withSD<IStripePaymentIntentSymbolsGroupProps>(StripeChargeSetupIntentSymbolsGroup)
);
export { stripePaymentIntentSymbolsGroup as StripeChargeSetupIntentSymbolsGroup };
